// import DataTableRow from './DataTableRow';
import PropTypes from 'prop-types';
import React from 'react';
// import classNames from 'classnames';

class RowsPerPageSelector extends React.Component {

  renderOpts() {
    const opts = this.props.rowsPerPageOpts.map((opt, i) => {
      return (
        <option key={i} value={opt}>{opt}</option>
      )
    });

    return opts;
  }

  render() {
    return (
      <div className='rows-per-page-selector'>
        <span className='label'>Rows per page: </span>
        <select value={this.props.rowsPerPage} onChange={(e) => this.props.onChangeRowsPerPage(parseInt(e.target.value))}>
          {this.renderOpts()}
        </select>
      </div>
    );
  }

  static propTypes = {
    rowsPerPageOpts: PropTypes.array.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    onChangeRowsPerPage: PropTypes.func.isRequired
  }
}

export default RowsPerPageSelector;